export default __webpack_public_path__ + "static/media/whatsapp-logo-icone.229565ba.png";